// Typelizer digest f096c4997cdd3062f99fc0dbf190a1d8
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../../runtime'
import { buildUrl } from '../../../runtime'

export default {
  /** POST /c/:company_id/overview/match_suggestions/:match_suggestion_id/rejection */
  create: (
    params: { matchSuggestionId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/overview/match_suggestions/:match_suggestion_id/rejection', params, options),
    method: 'post',
  }),
}
